import {Button} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {PullRequestReviewItem} from '../../../../page-data/payloads/timeline'
import {DockedPanel, useDockedPanelActions} from '../../../../contexts/DockedPanelContext'

export function PullRequestReviewAction({item}: {item: PullRequestReviewItem}) {
  const dockedPanelActions = useDockedPanelActions()
  const {reviewId, commentCount} = item.additionalInfo

  if (commentCount === 0) {
    return null
  }
  return (
    <Button
      onClick={() =>
        dockedPanelActions.openPanel(DockedPanel.Comments, {
          metadata: {filterText: `review-id:${reviewId}`, viewMode: 'review-comments'},
        })
      }
      size="small"
      variant="invisible"
      aria-label={`View ${commentCount} review comment${commentCount === 1 ? '' : 's'}`}
      leadingVisual={CommentIcon}
      className="flex-items-center"
    >
      {commentCount}
    </Button>
  )
}
